module.exports = __webpack_public_path__ + "img/portrait-mobile.2ceccdaa.jpg";